import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';

import { Trans } from 'react-i18next';
import { SectionTitle } from 'apps/group/styles';
import { FormWrapperDiv } from 'libs/forms/styles';
import { Divider } from 'legacyComponents/styled/lib';
import { Paragraph, Spinner } from 'components';
import { Form } from 'libs/forms';

@inject('clientStore')
@observer
export class AdminSettings extends React.Component {
  render() {
    const { projectSettingsAppManager, clientStore } = this.props;
    const { loading } = projectSettingsAppManager;

    if (!clientStore.isStaff) {
      return null;
    }

    if (loading) {
      return <Spinner margin='30px auto 40px' />;
    }

    return (
      <>
        <SectionTitle>
          <Trans>Admin zone</Trans>
        </SectionTitle>

        <Divider width='100%' />

        <FormWrapperDiv responsive>
          <Paragraph>
            <strong> Featured project</strong>
          </Paragraph>

          {projectSettingsAppManager.isFeatured === true && (
            <Paragraph>
              This project currently appears as <strong>Featured</strong>
            </Paragraph>
          )}
          {projectSettingsAppManager.isFeatured === false && (
            <Paragraph> This project now appears as Not featured</Paragraph>
          )}

          <Form
            formStore={projectSettingsAppManager.featuredProjectForm}
            buttonHandler={projectSettingsAppManager.confirmToggleFeatured}
            noBorder
            padding='0'
          />
        </FormWrapperDiv>

        <Divider width='100%' />

        <FormWrapperDiv responsive>
          <Paragraph>
            <strong> Change the project visibility</strong>
          </Paragraph>

          {projectSettingsAppManager.isPrivate === true && (
            <Paragraph>
              The visibility of the project is <strong>Private</strong>
            </Paragraph>
          )}
          {projectSettingsAppManager.isPrivate === false && (
            <Paragraph>
              The visibility of the project is <strong>public</strong>
            </Paragraph>
          )}

          <Form
            formStore={projectSettingsAppManager.projectVisibilityForm}
            buttonHandler={projectSettingsAppManager.confirmToggleVisibility}
            noBorder
            padding='0'
          />
        </FormWrapperDiv>

        <Divider width='100%' />

        <FormWrapperDiv responsive>
          <Paragraph>
            <strong> Transfer this project</strong>
          </Paragraph>
          <Form
            formStore={projectSettingsAppManager.transferForm}
            buttonHandler={projectSettingsAppManager.confirmTransferProject}
            noBorder
            padding='0'
          />
        </FormWrapperDiv>
      </>
    );
  }
}

AdminSettings.propTypes = {
  projectSettingsAppManager: PropTypes.object,
  clientStore: PropTypes.object,
};
